import { getRewardCenterFaqQueryClient } from "@workspace/casino_core/queries/RewardCenterFaqQuery.client";
import type { CmsLocaleInputType } from "@workspace/casino_core/schema";
import { CMS_BRAND_SLUG } from "../../constants";
import type { FaqItem } from "../../types";
import mapFaq from "./mapFaq";
import { IS_MOCK } from "./mock";

// Until the FAQ comes from the backend, question and answer hold CMS Phrase keys:
// FaqItem resolves them with `t()`, which passes any other text through as is.
const MOCK: FaqItem[] = [
  {
    id: "what-is-reward-center",
    question: "reward_center.faq.what_is_reward_center.question",
    answer: "reward_center.faq.what_is_reward_center.answer",
  },
  {
    id: "how-to-earn-xp",
    question: "reward_center.faq.how_to_earn_xp.question",
    answer: "reward_center.faq.how_to_earn_xp.answer",
  },
  {
    id: "what-are-tiers",
    question: "reward_center.faq.what_are_tiers.question",
    answer: "reward_center.faq.what_are_tiers.answer",
  },
  {
    id: "when-to-claim",
    question: "reward_center.faq.when_to_claim.question",
    answer: "reward_center.faq.when_to_claim.answer",
  },
  {
    id: "do-rewards-expire",
    question: "reward_center.faq.do_rewards_expire.question",
    answer: "reward_center.faq.do_rewards_expire.answer",
  },
];

const fetchFaq = async (
  locale?: CmsLocaleInputType,
): Promise<FaqItem[] | undefined> => {
  try {
    if (IS_MOCK) {
      if (Math.floor(Math.random() * 10) === 7) {
        throw new Error("Simulate failing");
      }
      return MOCK;
    }
    const { data } = await getRewardCenterFaqQueryClient({
      locale,
      where: { brandSlug: { equals: CMS_BRAND_SLUG } },
    });
    return mapFaq(data);
  } catch (error) {
    console.warn("[actors] fetching faq failed", error);
    return undefined;
  }
};

export default fetchFaq;
